const t = "styles-module__modal___7GJy2", o = "styles-module__fullscreen___rrgJD", e = "styles-module__closing___g7UCO", n = "styles-module__modalContent___zwCa0", _ = "styles-module__modalSimpleContent___5Ol95", s = "styles-module__authStyle___J-MhA", l = "styles-module__close___-5nmV", c = "styles-module__logo___7MTbQ", i = "styles-module__titleContainer___AN8Qs", r = "styles-module__titleIcon___lVWeZ", a = "styles-module__title___2gMGD", d = "styles-module__content___rc4Wh", y = "styles-module__description___03WjX", m = "styles-module__childrenContainer___Folgd", u = "styles-module__buttonContainer___Y1YTc", C = "styles-module__primaryButton___1A7gb", S = "styles-module__secondaryButton___uEh3I", p = "styles-module__footer___ZHN4i", g = "styles-module__separator___oIZ9A", T = "styles-module__secondarySectionContainer___zWakm", h = "styles-module__secondarySectionTextContainer___JLqWK", f = "styles-module__secondarySectionTitle___PoT9B", B = "styles-module__secondarySectionDescription___-TSXg", b = {
  modal: t,
  fullscreen: o,
  closing: e,
  modalContent: n,
  modalSimpleContent: _,
  authStyle: s,
  close: l,
  logo: c,
  titleContainer: i,
  titleIcon: r,
  title: a,
  content: d,
  description: y,
  childrenContainer: m,
  buttonContainer: u,
  primaryButton: C,
  secondaryButton: S,
  footer: p,
  separator: g,
  secondarySectionContainer: T,
  secondarySectionTextContainer: h,
  secondarySectionTitle: f,
  secondarySectionDescription: B
};
export {
  s as authStyle,
  u as buttonContainer,
  m as childrenContainer,
  l as close,
  e as closing,
  d as content,
  b as default,
  y as description,
  p as footer,
  o as fullscreen,
  c as logo,
  t as modal,
  n as modalContent,
  _ as modalSimpleContent,
  C as primaryButton,
  S as secondaryButton,
  T as secondarySectionContainer,
  B as secondarySectionDescription,
  h as secondarySectionTextContainer,
  f as secondarySectionTitle,
  g as separator,
  a as title,
  i as titleContainer,
  r as titleIcon
};
